<template>
  <div :class="['controls', {editing: editing, viewing: !editing}]" style="position:absolute;" v-if="annotation">

    <div class="upper">
      <div class="upper__left">
        <h2 v-if="!annotation.overlap">
          <span v-if="annotation.note">{{ editing ? ( (annotation.note && annotation.id) ? 'Edit' : 'Add') : '' }} Note</span>
          <span v-if="!annotation.note">Highlight</span>
        </h2>
        <h2 v-else>Annotations cannot overlap</h2>
        <div :class="['color-swatch', {active: swatchOpen}]" v-if="!annotation.overlap">
          <button @click="swatchOpen = !swatchOpen">
            <i :class="['color-swatch-item', 'color-'+annotation.colorId]" :title="(annotation.color) ? annotation.color.name : ''" tooltip></i>
            <sprite name="iconDownDir" v-if="editing" />
          </button>
          <annotation-swatch v-model="annotation.colorId" v-if="swatchOpen" @input="swatchOpen = false" />
        </div>
      </div>
      <div class="upper__right">
        <ul>
          <li v-if="on && annotation.id && !editing"><button @click="editing = true">Edit</button></li>
          <li v-if="on && annotation.id"><button @click="remove()">Remove</button></li>
          <li><clipboard :text="annotation.text" @copied="emit('close')">Copy</clipboard></li>
          <li><button class="icon-cancel" @click.stop.prevent="emit('close')"><sprite name="iconClose" /></button></li>
        </ul>
      </div>
    </div>

    <div class="note" v-if="editing || annotation.note">
      <p v-if="annotation.note && !editing" v-html="annotation.note"></p>
      <textarea-autogrow v-model="annotation.note" v-if="editing" placeholder="Type to add a note..." v-auto-focus @metaEnter="save()"></textarea-autogrow>
    </div>

    <button @click="save()" v-if="editing" class="save">{{ (annotation.id) ? 'Save' : 'Create' }} {{ (annotation.note) ? "Note" : "Highlight" }}</button>

  </div>
</template>

<script>

  import AnnotationSwatch from './swatch'
  import Clipboard from '@/components/_global/clipboard'

  export default {
    name: 'annotatorControls',
    props: {
      selection: Object,
      annotation: Object,
      on: Boolean
    },
    components: { AnnotationSwatch, Clipboard },
    data () {
      return {
        editing: !_.get(this.annotation, "id") && !_.get(this.annotation, "overlap"),
        quickResponse: false,
        swatchOpen: false
      }
    },
    mounted () {
      this.$emit('controlsMounted')
      $(this.$el).on("click", (e) => {
        e.stopPropagation()
      })
    },
    methods: {
      emit (event) {
        this.$emit(event)
      },
      save() {
        const method = (this.annotation.id) ? "DSSave" : "DSCreate"
        this.annotation[method]()
        this.$emit("close")
      },
      remove() {
        this.annotation.DSDestroy()
        this.$emit("close")
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  button {
    @include button-reset;
    @include font-size(xsmall);
    font-size:inherit; color:$color-primary;
  }

  .controls {
    @include transition();
    @include font-size(small);
    position:absolute; width:32rem; padding:1rem; z-index:101; background:$color-white; border:1px solid $color-gray; box-shadow:.3rem .5rem 2.5rem -.5rem rgba($color-black, .20), -.3rem .5rem 2.5rem -.5rem rgba($color-black, .20); transform:translateY(-100%);
    &::after, &::before {
      content:''; position:absolute; left:50%; transform:translateX(-50%)
    }
    &::before {
      @include triangle(22px, $color-gray, down);
      bottom:-11px;
    }
    &::after {
      @include triangle(20px, $color-white, down);
      bottom:-9px;
    }
    &.fade-up {
      &-enter {
        opacity:0; margin-top:10px;
      }
      &-leave-to {
        opacity:0;
      }
    }
    &.flipped {
      &::before, &::after {
        bottom:auto;
      }
      &::before {
        border:none;
        @include triangle(22px, $color-gray, up);
        top:-11px;
      }
      &::after {
        border:none;
        @include triangle(20px, $color-white, up);
        top:-9px;
      }
    }
  }

  .upper {
    @include font-size(small);
    display:flex; align-items:center; justify-content:space-between;
    &__left {
      display:flex; align-items:center;
    }
    h2 {
      font-size:inherit; font-weight:600;
    }
    ul {
      @include list-style-reset;
      display:flex; align-items:center;
    }
    li {
      margin-left:1rem;
    }
    svg {
      @include size(1.5rem);
    }
    button {
      @include transition();
      &:hover, &:focus {
        color:$color-primary-lighter; fill:$color-primary;
      }
    }
  }

  .note {
    margin:1rem 0;
  }

  .save {
    @include transition(color);
    @include button-reset;
    display:block; margin:0 auto; color:$color-primary;
    &:hover, &:focus {
      color:$color-primary-lighter;
    }
  }

  .color-swatch {
    margin-left:.75rem; position:relative;
    svg {
      @include transition(transform);
      transform:rotate(-90deg); backface-visibility:hidden;
    }
    &.active {
      svg {
        transform:rotate(0deg);
      }
    }
    .color-swatch-item {
      top:-1px; position:relative;
    }
    .swatch {
      top:2.75rem;
    }
  }
  .viewing .color-swatch {
    button {
      pointer-events:none;
    }
  }

  /deep/ .color-swatch-item {
    @include transition(background-color);
    display:inline-block; width:1.5rem; height:1.5rem; border-radius:.4rem; background:#ffdc19; vertical-align:middle; content:'';
    &.color {
      @each $color in $annotationColors {
        &-#{index($annotationColors, $color)} {
          background-color: $color !important;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Annotator/controls.vue